import React from "react";
import './Troubles.scss';
import { closeTroubles } from "../../Menu/MenuSide/menuSideSlice";

const Troubles = (props) => {
    const { dispatch } = props;
    const onClickEnd = () =>{
        dispatch(closeTroubles());
    }
    //RENDER
    const troublesView = props.troublesView;
    if (troublesView) {
        return (
            <div className="Trouble">
                <p> Вопросы</p>
                <button onClick={onClickEnd}>закрыть</button>
                   
            </div>
        )
    } else return null;
}
export default Troubles;